<div class="order" *ngIf="order && order.guests && (!basketDrinks.length && !basketFoods.length)">
    <div class="order-content">
        <span *ngIf="order.status === 'Created' || order.status === 'Updated' || order.status === 'Payment'">
        {{ 'yourOrderHasBeenSentToWaiters' | translate }}
        </span>
        <span *ngIf="order.status === 'Process'">
        {{ 'yourOrderIsAlreadyPlaced' | translate }}
        </span>
    </div>
    <div class="order-button" (click)="onOrderClicked(); $event.stopPropagation()">
        <div class="order-button__content">
            {{ 'order' | translate }}
            <mat-icon class="order-button__icon">description</mat-icon>
        </div>
    </div>
</div>